import type React from 'react';
import { useContext } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, FormProvider } from 'react-hook-form';
import { DealEditorFooter } from '~/components/common/deals/new/DealEditorFooter';
import type { DealParam } from '~/models/DealForm';
import {
  buildDealParam,
  validationSchemaV2 as validationSchema
} from '~/models/DealForm';
import { DealEditorBodyV2 } from './DealEditorBodyV2';
import { ItandiAccountContext } from '~/models/ItandiAccount';
import { useDealQueryParams } from '~/pages/deals/new';

export const DealEditor: React.FC = () => {
  const { company } = useContext(ItandiAccountContext);
  const { leasingId, dealType } = useDealQueryParams();

  const methods = useForm<DealParam>({
    mode: 'onBlur',
    resolver: yupResolver(validationSchema),
    shouldFocusError: false,
    defaultValues: buildDealParam({
      inspectionBy: company?.defaultInspectionBy ?? 'vendor',
      dealType,
      leasingId
    })
  });
  return (
    <div>
      <FormProvider {...methods}>
        <DealEditorBodyV2 />
        <DealEditorFooter />
      </FormProvider>
    </div>
  );
};
